import { useLocation } from 'react-router-dom';
import { ImageComponent } from './WorkoutCardList';

export default function Article() {
    // this grabs the data from each WorkoutCard to be rendered on this Article Page
    const location = useLocation();
    const { title, category, subCategory, content, username, picturePath } = location.state;
    
    // renders the Article contents from the WorkoutCard
    return (
      <main style={{backgroundColor: '#1d4b52'}}>
        <div className="article-body">
          <ImageComponent picturePath={picturePath} />
          <div className="article-text">
            <h2>{title}</h2>
            <b> Posted By: {username}</b>
            <p>{content}</p>
            <b>
              Exercise Tags:
            </b>
            <p>Tag 1: {category}</p>
            <p>Tag 2: {subCategory}</p>
          </div>
        </div>
      </main>
    );
}